import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y2018 = new LunarYear(
  moment.tz('2018-02-16 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [29, 30, 29, 30, 29, 29, 30, 29, 30, 29, 30, 30],
)

export default Y2018
